import { render, staticRenderFns } from "./person_change_detail.vue?vue&type=template&id=7ed7b0cb&scoped=true&"
import script from "./person_change_detail.vue?vue&type=script&lang=js&"
export * from "./person_change_detail.vue?vue&type=script&lang=js&"
import style0 from "./person_change_detail.vue?vue&type=style&index=0&id=7ed7b0cb&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed7b0cb",
  null
  
)

export default component.exports